module.exports = __webpack_public_path__ + "img/learning-1.accaee69.jpg";